import styled from 'styled-components';
import { Typography } from '../ui/Typography';

export const WhiteHeaderContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  padding: 0 15px;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.border.primary};

  .white-header--no-border {
    border-bottom: 0;
  }

  .white-header--center {
    position: relative;
    justify-content: center;
  }

  .white-header--main {
    justify-content: space-between;
    border-bottom: 0;
    padding: 15px;
    align-items: center;

    @media screen and (min-width: 744px) {
      height: 74px;
      padding: 15px 40px;
    }
  }

  .white-header--fixed {
    position: sticky;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 95;
    background: ${({ theme }) => theme.colors.background.primary};

    .scrolling & {
      border-bottom: 0.5px solid ${({ theme }) => theme.colors.border.primary};
    }

    ~ .placeholder-st {
      margin-top: 25px;
    }
  }
`;

export const WhiteHeaderTitle = styled(Typography)`
  text-align: center;
  margin: 0;
`;

export const WhiteHeaderWebviewBtn = styled.button`
  position: absolute;
  right: 0;
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 8px;
  padding: 0;

  i {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  svg {
    display: block;
    flex: 1;
  }
`;
